module.exports = __webpack_public_path__ + "media/images/pages/peel/spot-74686783c32482696571f0458e498aed.svg";